import { Box } from '@mui/material'

interface IScoreProps {
  glucoseScore: number
  color?: string
}

export const Score = ({ glucoseScore, color }: IScoreProps) => {
  return (
    <Box
      sx={{
        bgcolor: 'white',
        color,
        borderColor: color,
        backgroundColor: `${color}15`,
        borderWidth: 0.125,
        borderStyle: 'solid',
        textAlign: 'center',
        padding: '0 8px',
        borderRadius: '25px',
        fontWeight: 700
      }}
    >
      {glucoseScore}
    </Box>
  )
}
